module.exports = __webpack_public_path__ + "img/icon-stockpicker-loading@2x.6eac2681.png";